
import React, { MouseEvent, useEffect, useState, useRef } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import { useWindowSize } from 'react-use';

import { currentBasicTextFilterPropsAtom, currentFormNameAtom, currentUserSessionAtom, isSaveLoadingAtom } from 'library/store';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import { useMutation, useQuery, useQueryClient } from 'react-query';

import { useTheme } from '@mui/material/styles';

import { MenuItem, Card, CardContent, IconButton, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Checkbox } from "@mui/material";


import PrintIcon from "@mui/icons-material/Print";
import VisibilityIcon from '@mui/icons-material/Visibility';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';


import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { flexBetween, flexBetweenCenter, flexCenter, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

import { useBasicFilterSchoolYear } from 'features/setup/services/SchoolYear';
import useRegistrationService from 'features/production/services/Registration';

import { ISchoolYear, ISchoolYearClass } from 'features/setup/models/SchoolYear';

import { BasicTextFilterForm, defaultBasicTextFilterProps } from 'components/ui/BasicTextFilterForm';

import useEntityService from 'features/services/Entity';

import { Button } from '@mui/material';
import { MdCheckBox, MdCheckBoxOutlineBlank, MdOutlineChangeCircle, MdOutlineIndeterminateCheckBox } from 'react-icons/md';
import { FormDialog } from 'components/ui/FormDialog';

import useEnumerationService, { useBasicFilterEnumeration, useEnumerationItemCreateUpdate } from 'features/configuration/services/Enumeration';

import IEnumeration, {
  IEnumerationItem, Enum_STUDY_LEVEL, Enum_STUDY_LANGUAGE,
  Enum_STUDY_TYPE, Enum_STUDY_CYCLE, Enum_PERSON_GENDER,
  Enum_STUDY_SECTION
} from 'features/configuration/models/Enumeration';


import { isFalsy } from 'utility-types';
import { useNavigate } from 'react-router-dom';

import { debounce } from 'lodash';
import { IRegistration } from './models/Registration';
import { Cancel, CheckCircle } from '@mui/icons-material';
import { IResult } from 'library/interface';
import { useSnackbar } from 'notistack';


interface ClassInfo {
  id: number;
  classe: string;
  niveau: string;
  section: string;
  cycle: string;
  filles: number;
  garcons: number;
}

export const PreRegistrationsForm = () => {

  const theme = useTheme();

  const { t, i18n } = useTranslation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const { openEntityPrintDrawer, openEntityPrintDrawerEx, checkPrintAuthorization,
    hasEntityAuthorization, openEntityActionDrawer } = useEntityService();

  const [currentFormName, setCurrentFormName] = useRecoilState(currentFormNameAtom);
  const [isSaveLoading, setIsSaveLoading] = useRecoilState(isSaveLoadingAtom);

  const { language: lg, schoolYears, applicationSetup, roleEntities } = useRecoilValue(currentUserSessionAtom);
  const [schoolYearName, setSchoolYearName] = useState('');


  const [currentBasicTextFilterProps, setCurrentBasicTextFilterProps] = useRecoilState(currentBasicTextFilterPropsAtom);

  const { height, width } = useWindowSize();

  const { getPreRegistrations, batchValidateRegistrations, batchCancelPropositionRegistrations } = useRegistrationService();
  //const [dashboard, setDashboard] = useState<IDashboardSchoolYear>(defaultDashboardSchoolYear);

  const { getEnumerationItemsByEnumerationCodes, getExtensionEnumerationItemsBySchoolYear, getItemName } = useEnumerationService();


  const [openSchoolYearFilter, setOpenSchoolYearFilter] = useState(false);
  const basicFilterSchoolYear = useBasicFilterSchoolYear(
    async (event: React.MouseEvent<unknown>, row: ISchoolYear) => {
      const { id, name } = row;

      setSchoolYearId(id);
      setSchoolYearName(name);

      setOpenSchoolYearFilter(false);
    }
  );

  const { error, mutate: mutateBatchValidate } = useMutation<IResult<boolean>, Error, {registrationIds: number[]}>(
      batchValidateRegistrations, {
      onSuccess: (data: IResult<boolean>) => {
        enqueueSnackbar(t('_Operation_done'), {
          variant: 'success',
          anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 1000
        });
  
        setIsSaveLoading(false);        
      },
      onError: (err: Error) => {
        enqueueSnackbar(error?.message, {
          variant: 'error',
          anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
        });
        setIsSaveLoading(false);
      }
    });


    const { error: errCancelProposition, mutate: mutateBatchCancelProposition } = useMutation<IResult<boolean>, Error, {registrationIds: number[]}>(
      batchCancelPropositionRegistrations, {
      onSuccess: (data: IResult<boolean>) => {
        enqueueSnackbar(t('_Operation_done'), {
          variant: 'success',
          anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 1000
        });
  
        setIsSaveLoading(false);        
      },
      onError: (err: Error) => {
        enqueueSnackbar(error?.message, {
          variant: 'error',
          anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
        });
        setIsSaveLoading(false);
      }
    });


  const { data: enumItems, refetch: refetchEnumerationItems } = useQuery<IEnumerationItem[]>(['EnumerationItems', 'SchoolYearClassDashbord'], () => getEnumerationItemsByEnumerationCodes
    ([Enum_STUDY_LEVEL, Enum_STUDY_SECTION, Enum_STUDY_LANGUAGE, Enum_STUDY_TYPE, Enum_STUDY_CYCLE, Enum_PERSON_GENDER]));


  const handleClickSelectSchoolYear = (event: any) => {
    setOpenSchoolYearFilter(true);
  }

  const [schoolYearId, setSchoolYearId] = useState(0);

  const [schoolYearClassTemplateId, setSchoolYearClassTemplateId] = useState(0); // , 
  const [schoolYearClassId, setSchoolYearClassId] = useState(0);

  const [classOrder, setClassOrder] = React.useState<number>(0);
  const [studyType, setStudyType] = React.useState<string>('');
  const [studySection, setStudySection] = React.useState<string>('');
  const [studyLanguage, setStudyLanguage] = React.useState<string>('');
  const [studyCycle, setStudyCycle] = React.useState<string>('');
  const [studyLevel, setStudyLevel] = React.useState<string>('');
  const [gender, setGender] = React.useState<string>('');

  const refEnumItems = useRef<IEnumerationItem[]>();
  useEffect(() => {
    refEnumItems.current = enumItems;

  }, [enumItems]);

  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  // Selection handlers
  const handleSelect = (id: number) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    setSelectedIds(registrations.map((r) => r.id));
  };

  const handleUnselectAll = () => {
    setSelectedIds([]);
  };

  const handleInvertSelection = () => {
    setSelectedIds((prev) =>
      registrations.map((r) => r.id).filter((id) => !prev.includes(id))
    );
  };


  const [registrations, setRegistrations] = useState<IRegistration[]>([]);

  const handleNavigate2Registration = (registrationId: number) => {
    navigate(`/registration/${registrationId}`); // Adjust path as needed
  };

  const handlePrintRegistration = (registrationId: number) => {
    openEntityPrintDrawer('Registration', registrationId);
  };

  const handleActionRegistration = (registrationId: number) => {
    openEntityActionDrawer('Registration', registrationId);
  };

  const debouncedFilterChange = useRef(
    debounce(async (pSchoolYearId: number, pSchoolYearClassTemplateId: number, pSchoolYearClassId: number,
      pStudySection: string, pStudyLanguage: string, pStudyCycle: string, pStudyLevel: string, pOrder: number, pStudyType: string, pGender: string) => {

      const arr = await getPreRegistrations(pSchoolYearId, pSchoolYearClassTemplateId, pSchoolYearClassId,
        pStudySection, pStudyLanguage, pStudyCycle, pStudyLevel, pOrder, pStudyType, pGender);
      console.log(arr);
      setRegistrations(arr);

    }, 1000)
  ).current;

  useEffect(() => {
    async function _() {
      debouncedFilterChange(schoolYearId, schoolYearClassTemplateId, schoolYearClassId,
        studySection, studyLanguage, studyCycle, studyLevel, classOrder, studyType, gender);
    }
    _();
  }, [schoolYearId, schoolYearClassTemplateId, schoolYearClassId,
    studyType, studySection, studyLanguage, studyLevel, debouncedFilterChange]);


  useEffect(() => {
    setCurrentFormName(`${t('Pre-registration')}s ::`);
    setCurrentBasicTextFilterProps(defaultBasicTextFilterProps);
    setIsSaveLoading(false);
  }, []);

  useEffect(() => {
    async function _() {

      const schoolYear = schoolYears.find(s => s.id === applicationSetup.currentSchoolYearId);
      setSchoolYearName(schoolYear?.name || '');
      setSchoolYearId(schoolYear?.id || 0);

      debouncedFilterChange(applicationSetup.currentSchoolYearId, schoolYearClassTemplateId, schoolYearClassId,
        studySection, studyLanguage, studyCycle, studyLevel, classOrder, studyType, gender);
    }
    _();
  }, []);

  const printData = async (event: MouseEvent<HTMLButtonElement>) => {

    openEntityPrintDrawerEx('SchoolYearClassDashboard', 0, [{ name: 'SchoolYearId', value: schoolYearId, dateValue: new Date() },
    { name: 'StudyType', value: studyType, dateValue: new Date() }, { name: 'ClassOrder', value: classOrder, dateValue: new Date() },
    { name: 'StudyLevel', value: studyLevel, dateValue: new Date() }, { name: 'StudySection', value: studySection, dateValue: new Date() },
    { name: 'StudyLanguage', value: studyLanguage, dateValue: new Date() },
    { name: 'StudyCycle', value: studyCycle, dateValue: new Date() }, { name: 'Gender', value: gender, dateValue: new Date() }]);
  }


  // Actions
  const handleValidate = () => {
    if(selectedIds.length === 0) return;

    mutateBatchValidate({registrationIds: selectedIds});
  };

  const handleCancel = () => {
    if(selectedIds.length === 0) return;
    
    mutateBatchCancelProposition({registrationIds: selectedIds});
  };

  return (
    <Box sx={{ mx: 0.1 }}>
      <Grid container rowSpacing={1} columnSpacing={3}>


        <Grid item xs={12}>
          <Stack flexDirection='column'>
            <Box sx={{ ...justifyCenter, mt: 0.25, mb: 0.25 }} >
              <Button>
                <Typography variant="h6" id="tableTitle" color="primary" noWrap sx={{ ...typographyGroupBoxStyling }}>
                  {`:::: ${schoolYearName} :::::`}
                </Typography>
                <Box sx={{ ...justifyCenter, ml: 1 }} >
                  {`${t('Click to change school year')}`}
                  <MdOutlineChangeCircle size={24} onClick={handleClickSelectSchoolYear} />
                </Box>
              </Button>

              <Button id='btnPrint' onClick={printData} sx={{ display: 'none' }} />

            </Box>
            {openSchoolYearFilter && <FormDialog open={openSchoolYearFilter} maxWidth='md'
              okText='' cancelText='' title={t('School year')} onCancel={() => { }}
              onClose={() => { setOpenSchoolYearFilter(false); }} onOk={() => { setOpenSchoolYearFilter(false); }}  >
              <BasicTextFilterForm<ISchoolYear> {...basicFilterSchoolYear} />
            </FormDialog>}
          </Stack>
        </Grid>
        {/* ---- ACTION BAR ---- */}
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Stack direction="row" spacing={1}>
              <IconButton onClick={handleSelectAll} title="Select all">
                <MdCheckBox />
              </IconButton>
              <IconButton onClick={handleUnselectAll} title="Unselect all">
                <MdCheckBoxOutlineBlank />
              </IconButton>
              <IconButton onClick={handleInvertSelection} title="Invert selection">
                <MdOutlineIndeterminateCheckBox />
              </IconButton>
            </Stack>

            <Stack direction="row" spacing={1}>
              {roleEntities.some(re => re.entityName === 'Registration' 
                  && re.roleEntityFeatures.some(f => f.featureName === 'ValidateRegistrationHandler') ) && 
              <Button
                color="success"
                variant="contained"
                startIcon={<CheckCircle />}
                disabled={selectedIds.length === 0}
                onClick={handleValidate}
              >
                {t('Validate')}
              </Button>}
              {roleEntities.some(re => re.entityName === 'Registration' 
                  && re.roleEntityFeatures.some(f => f.featureName === 'CancelRegistrationHandler') ) && 
              <Button
                color="error"
                variant="contained"
                startIcon={<Cancel />}
                disabled={selectedIds.length === 0}
                onClick={handleCancel}
              >
                {t('Cancel')}
              </Button>}
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Stack flexDirection='column'>
            <Box sx={{
              mt: 1, width: '100%',
              display: 'grid', gap: 1.5, // spacing between items (adjust as needed)
              gridTemplateColumns: {
                xs: 'repeat(2, 1fr)',  // 2 per row on extra-small screens (sx)
                sm: 'repeat(3, 1fr)',  // 3 per row on small screens (sm)
                md: 'repeat(7, 1fr)',  // 6 per row on medium screens (md) and up
              },
            }} >
              <TextField select onChange={(evt) => setStudySection(evt.target.value)}
                value={studySection} sx={{ width: 'calc(100% - 8px)' }} id="studySection"
                label={t('Study section')} inputProps={{ readOnly: false }} focused >
                <MenuItem value=''>{':::'}</MenuItem>
                {enumItems && enumItems.filter(e =>
                  e.enumerationCode === Enum_STUDY_SECTION).map(
                    (x, idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem>)
                }
              </TextField>
              <TextField select onChange={(evt) => setStudyLanguage(evt.target.value)}
                value={studyLanguage} sx={{ width: 'calc(100% - 8px)' }} id="studyLanguage"
                label={t('Study language')} inputProps={{ readOnly: false }} focused >
                <MenuItem value=''>{':::'}</MenuItem>
                {enumItems && enumItems.filter(e =>
                  e.enumerationCode === Enum_STUDY_LANGUAGE).map(
                    (x, idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem>)
                }
              </TextField>
              <TextField select onChange={(evt) => setStudyCycle(evt.target.value)}
                value={studyCycle} sx={{ width: 'calc(100% - 8px)' }} id="studyCycle"
                label={t('Cycle')} inputProps={{ readOnly: false }} focused >
                <MenuItem value=''>{':::'}</MenuItem>
                {enumItems && enumItems.filter(e =>
                  e.enumerationCode === Enum_STUDY_CYCLE).map(
                    (x, idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem>)
                }
              </TextField>
              <TextField select onChange={(evt) => setStudyLevel(evt.target.value)}
                value={studyLevel} sx={{ width: 'calc(100% - 8px)' }} id="studyLevel"
                label={t('Study level')} inputProps={{ readOnly: false }} focused >
                <MenuItem value=''>{':::'}</MenuItem>
                {enumItems && enumItems.filter(e =>
                  e.enumerationCode === Enum_STUDY_LEVEL).map(
                    (x, idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem>)
                }
              </TextField>
              <TextField select onChange={(evt) => setClassOrder(Number(evt.target.value))}
                value={classOrder} sx={{ width: 'calc(100% - 8px)' }} id="classOrder"
                label={t('Order')} inputProps={{ readOnly: false }} focused >
                <MenuItem value={0}>{':::'}</MenuItem>
                {Array.from({ length: 17 }, (_, i) => i + 1).map(
                  (x, idx) => <MenuItem key={x} value={x}>{x}</MenuItem>)
                }
              </TextField>
              <TextField select onChange={(evt) => setStudyType(evt.target.value)}
                value={studyType} sx={{ width: 'calc(100% - 8px)' }} id="studyType"
                label={t('Study type')} inputProps={{ readOnly: false }} focused >
                <MenuItem value=''>{':::'}</MenuItem>
                {enumItems && enumItems.filter(e =>
                  e.enumerationCode === Enum_STUDY_TYPE).map(
                    (x, idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem>)
                }
              </TextField>
              <TextField select onChange={(evt) => setGender(evt.target.value)}
                value={gender} sx={{ width: 'calc(100% - 8px)' }} id="gender"
                label={t('Gender')} inputProps={{ readOnly: false }} focused >
                <MenuItem value=''>{':::'}</MenuItem>
                {enumItems && enumItems.filter(e =>
                  e.enumerationCode === Enum_PERSON_GENDER).map(
                    (x, idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem>)
                }
              </TextField>
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack flexDirection='column'>
            <Box p={2}>
              <Grid container spacing={2}>
                {registrations.filter(x => x.studyCycle.includes(studyCycle) && (classOrder <= 0 || x.classOrder === classOrder))
                  .map(({ id, fullNameFR, fullNameEN, schoolYearClassName, studyLanguage, studyCycle, amount }) => {

                    return (
                      <Grid key={id} item xs={12} sm={6} md={4} lg={3} xl={3} >
                        <Card sx={{ height: '100%', border: '1px solid #ccc', borderRadius: 2, boxShadow: 2, padding: 0.5, }}>
                          <CardContent>
                            <Box display="flex" justifyContent="space-between">

                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Checkbox
                                  checked={selectedIds.includes(id)}
                                  onChange={() => handleSelect(id)}
                                  color="primary"
                                />
                                <Typography sx={{ pl: 2, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                                  variant="h6" noWrap>
                                  {lg.includes('fr') ? fullNameFR : fullNameEN}
                                </Typography>
                              </Box>

                            </Box>
                            <Typography variant="body2" gutterBottom>
                              [{getItemName(enumItems, Enum_STUDY_LANGUAGE, studyLanguage)}] - {getItemName(enumItems, Enum_STUDY_CYCLE, studyCycle)}
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              [{schoolYearClassName} - {schoolYearName}]
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                              [{t('Amount')}  == {new Intl.NumberFormat('fr-FR').format(amount)}]
                            </Typography>
                            <Box mt={2} display="flex" justifyContent="space-around">
                              <IconButton color="primary" disabled={!hasEntityAuthorization('Registration')} onClick={() => handleNavigate2Registration(id)} aria-label="liste des élèves" >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton color="secondary" disabled={!checkPrintAuthorization('Registration')} onClick={() => handlePrintRegistration(id)} aria-label="imprimer">
                                <PrintIcon />
                              </IconButton>
                              <IconButton color="default" disabled={!hasEntityAuthorization('Registration')} onClick={() => handleActionRegistration(id)} aria-label="actions" >
                                <SystemUpdateAltIcon />
                              </IconButton>
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
              </Grid>

            </Box>
          </Stack>
        </Grid>
      </Grid>

    </Box>
  )
}
